export default {
    path : "land-carrier-all",
    name : "land-carrier-all",
    meta : {
        title : "全部载体"
    },
    component: () => import('@/pages/land/allCarrier/Index'),
    redirect: {
        name : "land-carrier-all-whole"
    },
    children: [
        {
            path: 'all',
            name: 'land-carrier-all-whole',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'recent',
            name: 'land-carrier-all-recent',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'atme',
            name: 'land-carrier-all-atme',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'meat',
            name: 'land-carrier-all-meat',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'reply',
            name: 'land-carrier-all-reply',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path: 'search',
            name: 'land-carrier-all-search',
            meta: {
                title: '土地载体-列表页'
            },
            component: () => import('@/pages/carrierCommon/List'),
        },
        {
            path : 'detail/:id',
            name : 'land-carrier-all-detail',
            metal: {
                title : '项目详细信息',
            },
            component: () => import('@/pages/carrierCommon/Detail'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/land/allcarrier/index.js